import styled, { css } from 'styled-components';
import type { Maybe } from 'yup';

import { Box } from '@/components/Box';
import {
  headingFontSizeDeskTopMap,
  headingFontSizeMobileMap,
} from '@/components/Cms/Heading/Heading.styles';
import { Col as BaseColumn } from '@/components/Col';
import { Flex } from '@/components/Flex';
import { NextImage } from '@/components/NextImage';
import { theme } from '@/theme';

import { visibilityControl } from '../../Card.styles';

export const Col = styled(BaseColumn)`
  height: 100%;
`;

export const ImageTeaserBox = styled(Flex)`
  display: flex;
  flex-direction: column;
  min-height: 135px;
  position: relative;
  ${({ theme }) => css`
    @media (min-width: ${theme.breakpoints.xs}) {
      width: 100%;
    }
  `}
`;
export const Media = styled(NextImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: relative !important;
`;

export const ImageTeaserContent = styled(Flex)`
  text-align: center;
  ${({ theme }) => css`
    padding: ${theme.spacing(2, 0)};
  `}
`;

export const Wrapper = styled(Flex)<{
  $visibleInDesktop?: Maybe<boolean>;
  $visibleInMobile?: Maybe<boolean>;
}>`
  height: 100%;
  margin: 0 auto;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  ${({ $visibleInDesktop, $visibleInMobile }) => css`
    ${visibilityControl($visibleInDesktop, $visibleInMobile)}
  `};
  ${({ theme }) => css`
    @media (min-width: ${theme.breakpoints.sm}) {
      padding-inline: 0;
      max-width: 470px;
    }
  `}
`;

export const ImageCtaWarpper = styled(Box)`
  width: 192px;
  ${theme.media.md.down} {
    width: 100%;
  }
  & a,
  button {
    width: 100%;
  }
`;

export const SubHeadingBox = styled.span<{
  $color: string;
  headingType?: string;
  textAlign?: string;
}>`
  ${({ $color, headingType }) => css`
  width: 100%;
  color: ${$color};
  font-size: ${headingType && headingFontSizeMobileMap[headingType]};
  font-family: ${theme.fontFamilies.italianPlate};
  font-weight: ${theme.fontWeights.bold};
  line-height:1;
  ${theme.media.md.up} {
    font-size: ${headingType && headingFontSizeDeskTopMap[headingType]};
  `}
`;
